export const domainConfig = {
  id: "ecommerce",
  name: "Thương mại điện tử",
  icon: "🛍️",
  description: "Tạo nội dung marketing cho shop online và TMĐT",

  projectTypes: {
    "Shop thời trang": 1,
    "Cửa hàng điện tử": 2,
    "Shop mỹ phẩm": 3,
    "Cửa hàng đồ gia dụng": 4,
    "Shop đồ trẻ em": 5,
    "Cửa hàng thể thao": 6,
    "Shop handmade": 7,
    "Cửa hàng sách": 8,
    "Shop thực phẩm": 9,
    "Cửa hàng nội thất": 10,
    "Marketplace tổng hợp": 11,
    "Dịch vụ dropshipping": 12,
  },

  contentTypes: {
    "Giới thiệu sản phẩm mới": 1,
    "Flash sale / Khuyến mại": 2,
    "Review sản phẩm": 3,
    "So sánh sản phẩm": 4,
    "Hướng dẫn sử dụng": 5,
    "Unboxing sản phẩm": 6,
    "Customer testimonial": 7,
    "Trend thời trang": 8,
    "Tips mua sắm": 9,
    "Chăm sóc khách hàng": 10,
    "Chính sách bảo hành": 11,
    "Tuyển dụng affiliate": 12,
  },

  defaults: {
    projectType: "Shop thời trang",
    contentType: "Giới thiệu sản phẩm mới",
    postLength: "Vừa phải",
    postStyles: ["Sáng tạo"],
  },

  labels: {
    projectTypeLabel: "Loại shop",
    contentTypeLabel: "Loại nội dung",
    projectInfoLabel: "Thông tin sản phẩm/shop",
    projectInfoPlaceholder:
      "Mô tả về sản phẩm, tính năng, giá cả, chính sách bán hàng...\n- Tên sản phẩm/shop\n- Tính năng nổi bật\n- Giá cả, khuyến mại\n- Chính sách đổi trả\n- Ưu đãi đặc biệt...",
    targetCustomerLabel: "Khách hàng mục tiêu",
    targetCustomerPlaceholder:
      "VD: Phụ nữ 25-35 tuổi, sinh viên, người làm văn phòng...",
  },

  settings: {
    requiresPrice: true,
    requiresImages: true,
    allowedImageTypes: ["product", "lifestyle", "comparison"],
  },
};
